import React from 'react';
import {Input} from "antd";
import { SearchOutlined, CloseOutlined } from '@ant-design/icons';
import pdf from '../../../icons/pdf.png';
import excel from '../../../icons/excel.png';
import print from '../../../icons/print.png';

const TableTop = ({setSearch}) => {
    return (
        <div className="table-content-top">
            <div className="table-top-left">
                <Input
                    prefix={<SearchOutlined className="site-form-item-icon" />}
                    placeholder="Search"
                    onChange={e=>setSearch(e.target.value)}
                />
            </div>
            <ul className="table-top-right">
                <li><button className="btn p-0"><img src={print} alt="404"/></button></li>
                <li><button className="btn p-0"><img src={pdf} alt="404"/></button></li>
                <li><button className="btn p-0"><img src={excel} alt="404"/></button></li>
            </ul>
        </div>
    );
};

export default TableTop;